"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
function Label({ children, size = 'medium', htmlFor, className, unbold = false, ...rest }) {
    return ((0, jsx_runtime_1.jsx)("label", { htmlFor: htmlFor, className: (0, classnames_1.default)(`label-${size}`, className, unbold ? 'unbold' : ''), ...rest, children: children }));
}
exports.default = Label;
